import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as sha1 from 'sha1';
import { CustomerService } from '../../customer.service';

@Component({
  selector: 'pv-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  errorMessage = '';

  constructor(
    private customerService: CustomerService,
    private router: Router
  ) { }

  ngOnInit() {
    this.registerForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      pass1: new FormControl('', [Validators.required, Validators.minLength(6)]),
      pass2: new FormControl('', [Validators.required, Validators.minLength(6)])
    }, { validators: this.validatePass })
  }

  validatePass(group: FormGroup): ValidationErrors | null {
    return group.get('pass1').value == group.get('pass2').value
      ? null
      : { pass2: true }
  }

  onSubmit() {
    this.errorMessage = ''
    // ############ #1096 send 'register' to createAccount so it knows to MERGE your guest cart with your newly created customer_id ############
    this.customerService.createAccount(this.registerForm.get('email').value, sha1(this.registerForm.get('pass1').value), null, 'register')
    .subscribe(
      x => this.router.navigate(['/profile']),
      err => {
        console.log(err.error.message.message)
        this.errorMessage = (err && err.error && err.error.message && err.error.message.message) || 'Unable to create account'
      }
    )
  }

}
